import { BaseMode } from './BaseMode';
import { UrlBuilder } from '@/core/UrlBuilder';
import type { WidgetConfig } from '@/types/config';
import type { EventBus } from '@/core/EventBus';

/**
 * Redirect mode - simple navigation to the target URL
 */
export class RedirectMode extends BaseMode {
  constructor(
    config: WidgetConfig,
    eventBus: EventBus,
    private button: HTMLButtonElement
  ) {
    super(config, eventBus);
  }

  public render(): void {
    // Setup button click handler
    this.button.addEventListener('click', this.handleButtonClick.bind(this));
  }

  private handleButtonClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    // Generate URL
    const url = UrlBuilder.generateUrl(this.config);

    // Navigate based on mode
    if (this.config.mode === 'new-tab') {
      // Open in new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      // Redirect in same tab
      window.location.href = url;
    }
  }

  public cleanup(): void {
    // Nothing to cleanup for redirect mode
  }
}
